import React, {
	forwardRef,
	ReactElement,
	Ref,
	useEffect,
	useState,
} from 'react';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { GrClose } from 'react-icons/gr';
import { PopupState } from '../jobportal';
import Loader from '../../../components/Loader';
import { services } from '../../../apis';

const Transition = forwardRef(function Transition(
	props: TransitionProps & {
		children: ReactElement;
	},
	ref: Ref<unknown>
) {
	return (
		<Slide
			direction="up"
			ref={ref}
			{...props}
		/>
	);
});

interface PopupProps {
	mockScorePopup: PopupState;
	setMockScorePopup: (newState: PopupState) => void;
}

const MockScorePopup = ({ mockScorePopup, setMockScorePopup }: PopupProps) => {
	const [loading, setLoading] = useState(false);
	const [mockScores, setMockScores] = useState([] as any[]);

	useEffect(() => {
		const fetchDrive = async () => {
			if (mockScorePopup.identifier !== '') {
				setLoading(true);
				const data =
                    await services.jobPortalService.fetchUserMockScores();
                console.log("mhfcjgfcfhc",data)
				setMockScores(data.data);
				setTimeout(() => {
					setLoading(false);
				}, 300);
			}
		};

		fetchDrive();
	}, [mockScorePopup]);

	const handleClose = () => {
		setMockScorePopup({
			isOpen: false,
			identifier: '',
		});
	};

	return (
		<Dialog
			open={mockScorePopup.isOpen}
			TransitionComponent={Transition}
			keepMounted
			onClose={handleClose}
			fullWidth={true}
			maxWidth="sm"
			className="thin-scrollbar"
		>
			<div className="job-portal-drives-popup-inner">
				{loading && (
					<div style={{ transform: 'scale(0.75)' }}>
						<Loader />
					</div>
				)}
				{!loading && (
					<>
						<div className="popup-header">
							<h2>
								{mockScorePopup.identifier} -{' '}
								{mockScores.length}
							</h2>
							<GrClose
								onClick={() => {
									handleClose();
								}}
							/>
						</div>
						{mockScores.length > 0 ? (
							<div className="popup-body">
								<table>
									<thead>
										<tr>
											<th> Session Name </th>
											<th> Mock Score </th>
											<th> Date </th>
										</tr>
									</thead>
									<tbody>
                                        {mockScores.map((item:any, idx) => (
											<tr key={idx}>
												<td>{item.sessionName}</td>
												<td>{item.mockScore}</td>
												<td>{item.date}</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						) : (
							<p>No data found.</p>
						)}
					</>
				)}
			</div>
		</Dialog>
	);
};

export default MockScorePopup;
